import './debugger.sass'

export { default } from './Debugger'
